{
  "about.blocks": "ನಿಯಂತ್ರಿತ ಸರ್ವರ್‌ಗಳು",
  "about.contact": "ಸಂಪರ್ಕ:",
  "about.disclaimer": "ಮಾಸ್ಟೋಡಾನ್ ಇದು ಉಚಿತ, ಮುಕ್ತ ತಂತ್ರಾಂಶ ಮತ್ತು Mastodon gGmbH ಇದರ ನೊಂದಾಯಿತ ಗುರುತು.",
  "about.domain_blocks.no_reason_available": "ಕಾರಣ ಲಭ್ಯವಿಲ್ಲ",
  "about.domain_blocks.preamble": "ಸಾಮಾನ್ಯವಾಗಿ ಮಾಸ್ಟೊಡಾನ್ ನಿಮಗೆ ಇತರೆ ಬಳಕೆದಾರರಿಂದ ಹಂಚಲ್ಪಟ್ಟ ವಿಷಯಗಳನ್ನು ನೋಡಲು ಮತ್ತು ಅವರೊಂದಿಗೆ ಸಂಭಾಷಿಸಲು ಅನುಮತಿಸುತ್ತದೆ.\nಆದರೆ ಈ ಸರ್ವ್ರರ್‌ನಲ್ಲಿ ಅಳವಡಿಸಲಾದ ಕೆಲವು ವಿನಾಯಿತಿಗಳು ಇಂತಿವೆ.",
  "account.add_or_remove_from_list": "ಪಟ್ಟಿಗೆ ಸೇರಿಸು ಅಥವ ಪಟ್ಟಿಯಿಂದ ತೆಗೆದುಹಾಕು",
  "account.badges.bot": "Bot",
  "account.badges.group": "ಗುಂಪು",
  "account.block_domain": "Hide everything from {domain}",
  "account.cancel_follow_request": "Withdraw follow request",
  "account.follow": "ಹಿಂಬಾಲಿಸಿ",
  "account.followers": "ಹಿಂಬಾಲಕರು",
  "account.posts": "ಟೂಟ್‌ಗಳು",
  "account.unblock_domain": "Unhide {domain}",
  "account_note.placeholder": "Click to add a note",
  "alert.unexpected.title": "ಅಯ್ಯೋ!",
  "bundle_column_error.retry": "ಮರಳಿ ಪ್ರಯತ್ನಿಸಿ",
  "column.domain_blocks": "Hidden domains",
  "column.pins": "Pinned toot",
  "community.column_settings.media_only": "Media only",
  "compose_form.encryption_warning": "Posts on Mastodon are not end-to-end encrypted. Do not share any dangerous information over Mastodon.",
  "compose_form.hashtag_warning": "This post won't be listed under any hashtag as it is unlisted. Only public posts can be searched by hashtag.",
  "compose_form.placeholder": "What is on your mind?",
  "compose_form.spoiler.marked": "Text is hidden behind warning",
  "compose_form.spoiler.unmarked": "Text is not hidden",
  "confirmations.delete.message": "Are you sure you want to delete this status?",
  "embed.instructions": "Embed this status on your website by copying the code below.",
  "empty_column.account_timeline": "No toots here!",
  "empty_column.bookmarked_statuses": "You don't have any bookmarked toots yet. When you bookmark one, it will show up here.",
  "empty_column.domain_blocks": "There are no hidden domains yet.",
  "empty_column.home": "Your home timeline is empty! Follow more people to fill it up. {suggestions}",
  "empty_column.list": "There is nothing in this list yet. When members of this list post new statuses, they will appear here.",
  "hashtag.column_settings.tag_toggle": "Include additional tags in this column",
  "keyboard_shortcuts.back": "to navigate back",
  "keyboard_shortcuts.blocked": "to open blocked users list",
  "keyboard_shortcuts.boost": "to boost",
  "keyboard_shortcuts.column": "to focus a status in one of the columns",
  "keyboard_shortcuts.compose": "to focus the compose textarea",
  "keyboard_shortcuts.down": "to move down in the list",
  "keyboard_shortcuts.enter": "to open status",
  "keyboard_shortcuts.federated": "to open federated timeline",
  "keyboard_shortcuts.heading": "Keyboard Shortcuts",
  "keyboard_shortcuts.home": "to open home timeline",
  "keyboard_shortcuts.legend": "to display this legend",
  "keyboard_shortcuts.local": "to open local timeline",
  "keyboard_shortcuts.mention": "to mention author",
  "keyboard_shortcuts.muted": "to open muted users list",
  "keyboard_shortcuts.my_profile": "to open your profile",
  "keyboard_shortcuts.notifications": "to open notifications column",
  "keyboard_shortcuts.open_media": "to open media",
  "keyboard_shortcuts.pinned": "to open pinned toots list",
  "keyboard_shortcuts.profile": "to open author's profile",
  "keyboard_shortcuts.reply": "to reply",
  "keyboard_shortcuts.requests": "to open follow requests list",
  "keyboard_shortcuts.search": "to focus search",
  "keyboard_shortcuts.spoilers": "to show/hide CW field",
  "keyboard_shortcuts.start": "to open \"get started\" column",
  "keyboard_shortcuts.toggle_hidden": "to show/hide text behind CW",
  "keyboard_shortcuts.toggle_sensitivity": "to show/hide media",
  "keyboard_shortcuts.toot": "to start a brand new toot",
  "keyboard_shortcuts.unfocus": "to un-focus compose textarea/search",
  "keyboard_shortcuts.up": "to move up in the list",
  "navigation_bar.domain_blocks": "Hidden domains",
  "not_signed_in_indicator.not_signed_in": "You need to sign in to access this resource.",
  "notification.reblog": "{name} boosted your status",
  "notifications.column_settings.status": "New toots:",
  "privacy.change": "Adjust status privacy",
  "report.placeholder": "Type or paste additional comments",
  "report.submit": "Submit report",
  "report.target": "Report {target}",
  "report_notification.attached_statuses": "{count, plural, one {# post} other {# posts}} attached",
  "search_results.statuses": "Toots",
  "sign_in_banner.sign_in": "Sign in",
  "status.admin_status": "Open this status in the moderation interface",
  "status.copy": "Copy link to status",
  "status.edited_x_times": "Edited {count, plural, one {# time} other {# times}}",
  "status.open": "Expand this status",
  "status.reblogs.empty": "No one has boosted this toot yet. When someone does, they will show up here.",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} people}} in the past {days, plural, one {day} other {# days}}",
  "upload_progress.label": "Uploading…"
}
